import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { CapaCreationContent } from './components/CapaCreationContent';

export default function CapaCreation() {
    return (
        <MainContent
            component={<CapaCreationContent />}
            titulo={'Nueva Capa'}
            noBackground
            tableMaxWidth
        />
    );

};